var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7878 40.306C42.3418 29.218 39.7008 16 35.3008 16C33.9568 16 32.7228 17.254 31.6118 19.739C28.0498 4 25.8108 4 24.8008 4C23.9008 4 22.0278 4 19.1128 15.116C18.3238 11 17.0478 11 16.3008 11C10.8188 11 7.37884 29.35 5.81584 40.288C5.78547 40.5007 5.80116 40.7175 5.86186 40.9237C5.92256 41.1298 6.02685 41.3205 6.16766 41.4829C6.30848 41.6452 6.48253 41.7754 6.67804 41.8646C6.87354 41.9538 7.08594 42 7.30084 42H18.3008C18.6476 42 18.9838 41.8799 19.2519 41.66C19.5201 41.4401 19.7039 41.1341 19.7718 40.794C20.4808 37.248 22.5698 32 24.8008 32C27.0318 32 29.1158 37.248 29.8298 40.8C29.899 41.139 30.0833 41.4436 30.3514 41.6623C30.6194 41.881 30.9549 42.0003 31.3008 42H42.3008C42.5142 41.9999 42.725 41.9544 42.9194 41.8664C43.1137 41.7783 43.287 41.6499 43.4277 41.4895C43.5685 41.3292 43.6734 41.1407 43.7355 40.9366C43.7976 40.7325 43.8154 40.5175 43.7878 40.306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCave);
export default __webpack_public_path__ + "static/media/cave.29e3cd908401000d1d959dcb3b3bb100.svg";
export { ForwardRef as ReactComponent };